import { render, staticRenderFns } from "./WavePickTask.vue?vue&type=template&id=0c70f701&scoped=true&"
import script from "./WavePickTask.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WavePickTask.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WavePickTask.vue?vue&type=style&index=0&id=0c70f701&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70f701",
  null
  
)

export default component.exports